import { useEffect, useState } from "react";
import { getUserDetails } from "../api/lead";
import { OwnerOption } from "./util-types";
import { useLogin } from "../common/hooks/useUser";

export const useLeadOwnerOptions = (leadId?: number, leadOwner?: any) => {
  const [options, setOptions] = useState<OwnerOption[]>([]);
  const [data, setData] = useState<any[]>([]); // array of users

  const { tenantDetails, userDetails } = useLogin();

  useEffect(() => {
    const fetchOwners = async () => {
      try {
        const response = await getUserDetails({}, "Lead Details");
        const apiData = response.data.data.data.data;
        setData(apiData);
      } catch (error) {
        console.error("Failed to fetch owners", error);
      }
    };

    fetchOwners();
  }, []);

  useEffect(() => {
    if (!tenantDetails) return; // wait for login details

    let ownerData: any[] = [];
    if (leadOwner?.id) {
      ownerData = [{ ...leadOwner }]
    }
    else if (tenantDetails?.tenantType === "Tenant") {
      // Single user, using userDetails fields
      ownerData = [
        {
          ...userDetails,
          first_name: userDetails.firstName,
          last_name: userDetails.lastName,
        },
      ];
    } else {
      // Filter super admins (role_id === 1)
      ownerData = data?.filter((item: any) => item?.role_id === 1) || [];
    }

    const formattedOptions: OwnerOption[] = ownerData.map((user: any) => ({
      id: user.id,
      value: `${user.first_name} ${user.last_name}`,
      label: `${user.first_name} ${user.last_name}`,
    }));

    setOptions(formattedOptions);
  }, [tenantDetails, userDetails, data]);

  return options;
};
